import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { GET_ROUTE_WAYPOINT_STATUS } from 'graphql/route/queries';




export function BoatRouteWaypointStatusDropdown({ fields, error, helperText, purpose }) {

  const { t } = useTranslation()
  const [routeTripStatusList, setRouteTripStatusList] = useState([]);
  const [getRouteTripStatusList, { loading: tripStatusListLoading, error: tripStatusListError }] = useLazyQuery(GET_ROUTE_WAYPOINT_STATUS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatRouteWaypointStatus.length > 0) {
        setRouteTripStatusList(data.boatRouteWaypointStatus);
      }
    },
  });

  // get Type List
  const getBoatStatus = () => {
    getRouteTripStatusList({
      variables: {
        code: null
      },
    });
  };

  useEffect(() => {
    getBoatStatus();
  }, []);

  return (
    <>
      {tripStatusListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {tripStatusListError && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!tripStatusListLoading && !tripStatusListError && routeTripStatusList?.length === 0 && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!tripStatusListLoading && !tripStatusListError && routeTripStatusList?.length > 0 && (
        <select
          {...fields}
          value={fields.value || ""} // Ensure value is a string
          onChange={(e) => {
            fields.onChange(e);  // Update Formik's value
          }}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {purpose === 'filter' ? <option value=""> {t('All')} </option> : <option value="" disabled> {t('Select Status')} </option>}
          {routeTripStatusList.map((routeTrip) => (
            <option key={routeTrip.code} value={routeTrip.code}>
              {routeTrip.description.en}
            </option>
          ))}
        </select>
      )}
      {/* {error && <p className="text-error text-xs mt-1">
        {helperText}
      </p>} */}
    </>
  );
}

BoatRouteWaypointStatusDropdown.propTypes = {
  fields: PropTypes.object.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  purpose: PropTypes.string
};
